<template>
<v-layout class="pointer" py-1>
  <v-layout align-center @click="clicked" style="width: 185px;">
    <v-icon v-if="isSelected" color="primary" class="mr-1">mdi-check</v-icon>
    <v-icon v-else class="mr-1">mdi-blank</v-icon>
    <div class="prevent-overflow" style="overflow: hidden">
      <div v-for="(subRow, i) in row.rows" :key="`flist-${row.id}-${i}`">
        {{subRow}}
      </div>
    </div>
  </v-layout>
  <v-layout v-if="showDefaultOption || showDeleteOption" class="mr-4">
    <v-checkbox v-if="showDefaultOption" v-model="isDefaultSearch" color="primary" style="display: -webkit-box;" class="mr-2"></v-checkbox>
    <v-btn v-if="showDeleteOption" flat icon color="error" @click="deleteFilter(row)">
      <v-icon class="d-inline-block">close</v-icon>
    </v-btn>
  </v-layout>
</v-layout>
</template>

<script>
  import { DELETE_SAVED_FILTER, SAVE_UPDATE_MY_FILTER } from '../../store/action-types'
  import { mapActions } from 'vuex'

export default {
    name: 'my-filter-list-row',
    props: {
      row: {
        type: Object,
        required: true
      },
      idSet: {
        type: Set,
        required: true
      },
      deleteFilter: {
        type: Function,
        required: true
      },
      selectedButtonText: {
        type: Function,
        required: true
      },
      showDefaultOption: {
        type: Boolean,
        required: true
      },
      showDeleteOption: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      clicked () {
        // if clicked, pass button text
        this.selectedButtonText(this.row.rows.toString())
        this.$emit('selected', {id: this.row.id, selected: !this.isSelected})
      },
      ...mapActions({
        saveMyFilter: SAVE_UPDATE_MY_FILTER,
        deleteSavedFilter: DELETE_SAVED_FILTER
      })
    },
    computed: {
      isSelected () {
        return this.idSet.has(this.row.id)
      },
      isDefaultSearch: {
        get () {
          return this.row.defaultSearch
        },
        set (value) {
          // if set default, pass button text
          this.selectedButtonText(this.row.rows.toString())
          this.saveMyFilter({
            description: this.row.rows.toString(),
            defaultSearch: value,
            id: this.row.id,
            defaultAction: true})
        }
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/MyFilterListRow.vue